import { createI18n } from 'vue-i18n';

import enUsTranslations from '../lang/en-us.json';
import enCaTranslations from '../lang/en-ca.json';

const messages = {
    'en-US': enUsTranslations,
    'en-CA': enCaTranslations,
};

export default function mergeTranslations(locale, overrides) {
    const translations = JSON.parse(JSON.stringify(messages));

    if (messages[locale] == null) {
        messages[locale] = {};
    }

    if (overrides) {
        Object.keys(overrides).forEach((k) => {
            if (overrides[k]) {
                messages[locale] = overrides[k];
            }
        });
    }

    return createI18n({
        locale,
        fallbackLocale: 'en-US',
        messages: translations,
        silentTranslationWarn: true,
        silentFallbackWarn: true,
    });
}
